import userConstants from "../constants/userConstants";

export const retrieveUsers = (payload: any) => ({
  type: userConstants.GET_USERS_LIST,
  payload,
});

export const getUserSingup = (payload: any) => ({
  type: userConstants.GET_USER_SIGNUP_REQUEST,
  payload,
});

export const updateSingupRequest = (payload: any) => ({
  type: userConstants.UPDATE_SIGNUP_REQUEST,
  payload,
});

export const sendSingupRequest = (payload: any) => ({
  type: userConstants.SEND_USER_SIGNUP_REQUEST,
  payload,
});

export const retrieveUserDetails = () => ({
  type: userConstants.GET_USER_DETAILS,
});

export const createuser = (payload: any) => ({
  type: userConstants.CREATE_USER_REQ,
  payload,
});

export const edituser = (payload: any) => ({
  type: userConstants.EDIT_USER_REQUEST,
  payload,
});

export const retrieveUserRoles = () => ({
  type: userConstants.GET_ROLES_LIST,
});

export const login = (payload: any) => ({
  type: userConstants.LOGIN_REQUEST,
  payload,
});

export const logout = (payload: any) => ({
  type: userConstants.LOGOUT_REQUEST,
  payload,
});

export const refreshToken = (payload: any) => ({
  type: userConstants.REFRESH_TOKEN_REQUEST,
  payload,
});

export const resetSignupRequest = () => ({
  type: userConstants.RESET_SIGNUP_REQUEST,
});

export const resetUsers = () => ({
  type: userConstants.RESET_USERS,
});
